/* Minimal JS: copy code + tiny inline message + optional browser notification. */
(function () {
  function copyToClipboard(text) {
    if (!text) return Promise.reject();
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // Fallback for older browsers / http
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    var ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok ? Promise.resolve() : Promise.reject();
  }

  function notifyBrowser(msg) {
    try {
      if (!('Notification' in window)) return;
      if (Notification.permission === 'granted') {
        new Notification(msg);
      } else if (Notification.permission === 'default') {
        Notification.requestPermission().then(function (perm) {
          if (perm === 'granted') new Notification(msg);
        });
      }
    } catch (e) { /* ignore */ }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.bj-coupon-landing');
    if (!root) return;

    var code = (root.getAttribute('data-code') || '').trim();
    var toast = root.querySelector('.bj-toast');

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy]');
      if (!btn) return;

      copyToClipboard(code).then(function () {
        if (toast) {
          toast.textContent = 'Coupon code copied';
          toast.classList.add('is-visible');
          setTimeout(function(){ toast.classList.remove('is-visible'); toast.textContent=''; }, 1600);
        }
        
      }).catch(function(){
        if (toast) {
          toast.textContent = 'Select and copy the code';
          toast.classList.add('is-visible');
          setTimeout(function(){ toast.classList.remove('is-visible'); toast.textContent=''; }, 2000);
        }
      });
    });
  });
})();
